import { FaqSection, FaqItem } from '../../../../../api/types/faq-content-api';
import { IBreadcrumb } from './BreadcrumbSeoScript';

export const buildFaqBreadcrumb = (faqSection?: FaqSection, faq?: FaqItem): IBreadcrumb[] => {
    const faqBreadcrumb = [
        {
            name: 'Help Center',
            url: '/help-center'
        },
        {
            name: faqSection?.sectionTitle || '',
            url: faqSection?.url || ''
        }
    ];
    if (faq) {
        faqBreadcrumb.push({ name: faq.question, url: faq.url });
    }
    return faqBreadcrumb;
};
